<template>
  <div>
    <el-row>
      <el-col :span="12">
        <span class="explain-title">机构级次：</span>
        <span class="explain-content">{{ LogDetail.orgRank | commonFilterName('医院级别') }}</span>
      </el-col>
      <el-col :span="12">
        <span class="explain-title">机构类别：</span>
        <span class="explain-content">{{ LogDetail.orgType | commonFilterName('医院分类')}}</span>
      </el-col>
      <el-col :span="12">
        <span class="explain-title">机构等级：</span>
        <span class="explain-content">{{ LogDetail.orgGrade | commonFilterName('医院等次')}}</span>
      </el-col>
      <el-col :span="12">
        <span class="explain-title">行业地位：</span>
        <span class="explain-content">{{ LogDetail.tradeLevel || '-'}}</span>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  props: {
    LogDetail: { // 详情
      type: Object,
      default: {},
    }
  },
};
</script>

<style lang="less" scoped>
.el-col-12 {
  display: flex;
  margin-bottom: 15px;
}
.explain-title {
  flex-shrink: 0;
}
.explain-content {
  text-align: left;
  display: inline-block;
  /* line-height: 30px; */
}
</style>